import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle } from "@/components/GlassBits";
import { formatDate } from "@/lib/format";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => setItems((await api.get("/admin/audit-logs")).data))(); }, []);

  return (
    <div>
      <SectionTitle eyebrow="Security" title="Audit Log" />
      <div className="ldc-glass overflow-hidden">
        <div className="overflow-x-auto ldc-scroll">
          <table className="w-full ldc-table" data-testid="audit-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Actor</th>
                <th>Entity</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (<tr><td colSpan={5} className="text-center py-10 text-white/40">No audit events.</td></tr>)}
              {items.map((a) => (
                <tr key={a.id}>
                  <td className="text-xs text-white/50 whitespace-nowrap">{formatDate(a.created_at)}</td>
                  <td className="font-mono text-xs text-[#fbce18]">{a.action}</td>
                  <td className="text-xs">{a.user_email || "system"}</td>
                  <td className="text-xs text-white/70">{a.entity || "—"} <span className="text-white/40">{a.entity_id || ""}</span></td>
                  <td className="text-xs text-white/40">{a.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
